var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("开通的服务城市？")]),_c('div',{staticClass:"content-info"},[_c('p',{staticClass:"txt1",attrs:{"id":"citysHelp"}},[_vm._v("目前全国开通城市，包括为北京、天津、上海、杭州、温州、济南、青岛、郑州、合肥、武汉、广州、深圳、东莞、南京、常州、苏州、无锡、成都、重庆、西安、长沙等城市。")])])])
}]

export { render, staticRenderFns }